let PackagesItem = [
    {
        trackTitle: "Full Recordings",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "150",
        trackFullPrice: '800',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Event recordings',
        trackLink: 'https://geekle.us/ticket/1687769680018x914740694633152500',
        // earlyBird: true,
    },
    // {
    //     trackTitle: "NO RECORDINGS access",
    //     trackSubtitle: "For Junior specialists",
    //     trackPrice: "125",
    //     trackNextPrice: "500",
    //     trackFullPrice: '500',
    //     trackButton: "Register",
    //     trackLink: 'https://geekle.us/ticket/1679302671115x247901392638050300',
    //     // earlyBird: true,
    // },
    {
        trackTitle: `AI in Web Design Conf'23
+`,
        secondEvent: "UI/UX Global Summit'23 Vol.2",
        secondEventLink: "https://events.geekle.us/uiux232/",
        trackPrice: "1000",
        trackFullPrice: '1000',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Two Live events + Recordings',
        trackLink: 'https://geekle.us/ticket/1679304208060x236990707406209020',
    },
    {
        trackTitle: "ChatGPT best practices Package",
        event1: "AI in Web Design Conf'23",
        event2: "GPTcoding for Frontend Developers Conference'23",
        event2Link: "https://events.geekle.us/gpt/",
        event3: "GPTcoding for Backend Developers Summit’23",
        event3Link: "https://events.geekle.us/gpt-backend/",
        trackPrice: "1200",
        trackFullPrice: '1200',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1685964204282x110904800060375040',
        validDate: '16.06',
        inverseColors: true,
    },
    // {
    //     trackTitle: "Year of AI in Web Design Events",
    //     year: "Full Access to the live stream and recordings for 4 events in the AI in Web Design domain",
    //     trackPrice: "549",
    //     trackFullPrice: '1200',
    //     trackDesc: "1",
    //     trackButton: "Register",
    //     trackList1: 'Live event + Recordings',
    //     trackLink: 'https://geekle.us/ticket/1683107963544x543405518425686000',
    // },
];

export default PackagesItem;
